<div class="modal-header">
    <h5 class="modal-title">Update role</h5>
    <button type="button" class="btn btn-link close pull-right" aria-label="Close" (click)="close()">
        <i class="fa fa-lg fa-times"></i>
    </button>
</div>

<div class="modal-body">
  <form [formGroup]="roleForm">

      <div class="row">
        <div class="col-24 ps-2 pb-2">
          <label>Name</label>
          <input type="text"  class="form-control" formControlName="name">
        </div>
      </div>

      <div class="row">
        <div class="col-24 ps-2 pb-2">
          <label>Description</label>
          <input type="text"  class="form-control" formControlName="description">
        </div>
      </div>

      <div class="row">
        <div class="col-24 ps-2 pb-2">
          <label>Permissions</label>
          <ng-select formControlName="permissions" [items]="permissions" [bindLabel]="'permission'" [multiple]="true"></ng-select>
        </div>
      </div>

  </form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary"
            (click)="update()"
            [disabled]="roleForm.invalid">
        <i class="fa fa-lg fa-plus-circle"></i>
        Submit
    </button>

    <button class="btn btn-outline-primary"
            (click)="close()">
        Close
    </button>
</div>
